import React from 'react';
import { useSearchParams } from 'react-router-dom';
import WorkspaceLoadingScreen from './WorkspaceLoadingScreen';
import { WORKSPACE_LOADER_MIN_MS } from './useMinimumVisibleLoading';
import './WorkspaceLoadingScreen.css';

const PRESETS = [
  { id: 'workspace', message: 'Preparing your workspace...' },
  { id: 'finalize', message: 'Finalizing your account setup...' },
];

/**
 * /app/test/workspace-loading
 * /app/test/workspace-loading?preset=auth&theme=dark
 */
const WorkspaceLoadingTestPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const presetId = searchParams.get('preset') || 'workspace';
  const preset = PRESETS.find((p) => p.id === presetId) || PRESETS[1];
  const message = searchParams.get('message') || preset.message;
  const themeMode = searchParams.get('theme') === 'dark' ? 'dark' : 'light';

  const updateParams = (updates) => {
    const next = new URLSearchParams(searchParams);
    Object.entries(updates).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') {
        next.delete(key);
      } else {
        next.set(key, value);
      }
    });
    setSearchParams(next, { replace: true });
  };

  return (
    <>
      <WorkspaceLoadingScreen message={message} themeMode={themeMode} />

      <aside className="workspaceLoadingTest" aria-label="Workspace loading preview controls">
        <p className="workspaceLoadingTest__title">Loader preview</p>

        <label className="workspaceLoadingTest__label" htmlFor="wlt-message">
          Message
        </label>
        <input
          id="wlt-message"
          className="workspaceLoadingTest__field"
          value={message}
          onChange={(e) => updateParams({ message: e.target.value, preset: null })}
        />

        <p className="workspaceLoadingTest__label">Theme</p>
        <div className="workspaceLoadingTest__row">
          <button
            type="button"
            className={`workspaceLoadingTest__btn${themeMode === 'light' ? ' isActive' : ''}`}
            onClick={() => updateParams({ theme: 'light' })}
          >
            Light
          </button>
          <button
            type="button"
            className={`workspaceLoadingTest__btn${themeMode === 'dark' ? ' isActive' : ''}`}
            onClick={() => updateParams({ theme: 'dark' })}
          >
            Dark
          </button>
        </div>

        <p className="workspaceLoadingTest__label">Presets</p>
        <div className="workspaceLoadingTest__row">
          {PRESETS.map((p) => (
            <button
              key={p.id}
              type="button"
              className={`workspaceLoadingTest__btn${presetId === p.id ? ' isActive' : ''}`}
              onClick={() => updateParams({ preset: p.id, message: null })}
            >
              {p.id}
            </button>
          ))}
        </div>

        <p className="workspaceLoadingTest__hint">
          Min visible: {WORKSPACE_LOADER_MIN_MS}ms · /app/test/workspace-loading
        </p>
      </aside>
    </>
  );
};

export default WorkspaceLoadingTestPage;
